import { StringUtils, UriUtils } from '@ad-lucy/utils';

export function getDoohPreloadTime(): number {
  const doohPreloadTimeString = UriUtils.getQueryParamByName(
    window.location.href,
    'DOOHpreloadTime',
  );
  const doohPreloadTime = StringUtils.toInt(doohPreloadTimeString);

  if (doohPreloadTime === undefined || doohPreloadTime < 0) {
    return -1;
  }

  return doohPreloadTime;
}
